import { Combobox } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'


export class MgiResultColumn extends RegisterColumn {
  static type = REGISTER_COLUMNS.MGI_RESULT


  constructor (store, settings) {
    const column = {
      header: {
        title: 'Наличие патологии на неонатальном скрининге МГИ',
        component: Combobox,
        props: {
          allowClear: true,
          placeholder: 'Все',
          options: [
            { label: 'Обнаружено', value: 'Обнаружено', title: 'Обнаружено' },
            { label: 'Не обнаружено', value: 'Не обнаружено', title: 'Не обнаружено' },
          ],
        },
      },
      width: 300,
      dataIndex: 'mgi_result',
      dataRender: mgi_result => mgi_result ? mgi_result : '-',
      sort: true,
      nullSearch: true,
    }

    super(column, settings)
  }

  _requestArgs ({ filters, nullSearches }) {
    let requestFilters = []

    if (filters?.mgi_result) {
      requestFilters = [{ field: 'mgi_result', value: filters.mgi_result, operator: '=', invalid: false }]
    }

    if (nullSearches[this.type]) {
      requestFilters = [{ field: this.type, operator: '=', value: '-', invalid: false }]
    }

    return {
      control: {
        filters: requestFilters,
      },
    }
  }
}
